import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { PrintHeader } from 'js/components/print';

const CaseLogPrintHeader = (props) => {
  const { className, ...headerProps } = props;

  return (
    <PrintHeader
      className={classnames('case-print-header', className)}
      {...headerProps}
    />
  );
};

CaseLogPrintHeader.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  heading: PropTypes.string,
};

export default CaseLogPrintHeader;
